if (!customElements.get('service-body-install-quote')) {
  customElements.define('service-body-install-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.nativeForm = document.getElementById(this.dataset.productForm);
      this.trigger = this.nativeForm?.querySelector('[data-service-body-install-quote]');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-install-form]');
      this.fields = this.querySelector('[data-install-fields]');
      this.submit = this.querySelector('[data-install-submit]');
      this.restart = this.querySelector('[data-install-new]');
      this.status = this.querySelector('[data-install-status]');
      this.reference = this.querySelector('[data-install-reference]');
      this.result = this.querySelector('[data-install-result]');
      this.changed = this.querySelector('[data-install-changed]');
      this.storageKey = `service-body-install-quote:v1:${this.config.bundleHandle}`;
      try {
        const probe = `${this.storageKey}:probe`;
        sessionStorage.setItem(probe, '1');
        sessionStorage.removeItem(probe);
        this.attempt = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        if (this.attempt && (!this.attempt.payload || !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(this.attempt.payload.submissionId))) throw new Error('storage_error');
        if (!crypto.randomUUID) throw new Error('storage_error');
        this.storageReady = true;
      } catch (_) {
        this.storageReady = false;
      }
      try {
        if (!this.dataset.endpoint) throw new Error();
        const endpoint = new URL(this.dataset.endpoint, location.origin);
        if ((endpoint.protocol !== 'https:' && !(endpoint.protocol === 'http:' && endpoint.hostname === 'localhost')) || endpoint.pathname !== '/api/checkout') throw new Error();
        endpoint.pathname = '/api/install-quote';
        endpoint.search = '';
        endpoint.hash = '';
        this.endpoint = endpoint.href;
      } catch (_) {}
      if (this.attempt) {
        for (const [key, value] of Object.entries({ ...this.attempt.payload.customer, installLocation: this.attempt.payload.installLocation })) {
          const control = this.form.elements.namedItem(key);
          if (control) control.value = value;
        }
        for (const control of this.form.querySelectorAll('[name="installOptions"]')) {
          control.checked = this.attempt.payload.installOptions?.includes(control.value) === true;
        }
        this.show(this.attempt);
      }
      this.openHandler = event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.syncSelection();
        if (this.trigger?.disabled) return;
        this.dialog.showModal();
        if (this.attempt) this.show(this.attempt);
        if (!this.storageReady) this.message('storage_error');
        else if (!this.endpoint) this.message('unavailable');
      };
      this.closeHandler = () => this.dialog.close();
      this.closedHandler = () => this.trigger?.focus();
      this.submitHandler = event => this.send(event);
      this.restartHandler = () => {
        if (this.busy || this.attempt?.status !== 'quote_ready') return;
        try { sessionStorage.removeItem(this.storageKey); } catch (_) { this.message('storage_error'); return; }
        this.attempt = null;
        for (const control of this.form.querySelectorAll('[name="installOptions"]')) control.checked = false;
        this.status.textContent = '';
        this.status.classList.remove('service-body-install-quote-ready');
        this.reference.hidden = true;
        this.result.hidden = true;
        this.changed.hidden = true;
        this.restart.hidden = true;
        this.fields.disabled = false;
        this.submit.hidden = false;
        this.submit.textContent = this.config.messages.submit;
        this.syncSelection();
        if (this.submit.disabled) this.message('selection_error');
        this.form.elements.namedItem('firstName').focus();
      };
      this.selectionHandler = () => this.syncSelection();
      this.trigger?.addEventListener('click', this.openHandler);
      this.nativeForm?.addEventListener('submit', this.openHandler, { capture: true });
      this.nativeForm?.addEventListener('change', this.selectionHandler);
      this.nativeForm?.addEventListener('input', this.selectionHandler);
      this.querySelector('[data-install-close]').addEventListener('click', this.closeHandler);
      this.dialog.addEventListener('close', this.closedHandler);
      this.form.addEventListener('submit', this.submitHandler);
      this.restart.addEventListener('click', this.restartHandler);
      this.syncSelection();
      customElements.whenDefined('service-body-vehicle').then(() => {
        if (this.isConnected) this.syncSelection();
      });
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.openHandler);
      this.nativeForm?.removeEventListener('submit', this.openHandler, { capture: true });
      this.nativeForm?.removeEventListener('change', this.selectionHandler);
      this.nativeForm?.removeEventListener('input', this.selectionHandler);
      this.querySelector('[data-install-close]')?.removeEventListener('click', this.closeHandler);
      this.dialog?.removeEventListener('close', this.closedHandler);
      this.form?.removeEventListener('submit', this.submitHandler);
      this.restart?.removeEventListener('click', this.restartHandler);
      this.ready = false;
    }

    selection() {
      const selector = this.nativeForm?.querySelector('service-body-vehicle');
      const vehicle = selector?.selection();
      const quantity = Number(this.nativeForm?.elements.namedItem('quantity')?.value || 1);
      const trundle = this.nativeForm?.querySelector('[data-extras-trundle]')?.value || '1000';
      const waterTank = this.nativeForm?.querySelector('[data-extras-water]')?.value === 'true';
      const wheelGuards = this.nativeForm?.querySelector('[data-extras-wheel-guards]')?.value || 'standard';
      if (!vehicle || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 10 || !['1000', '1500'].includes(trundle)
        || !['standard', 'wide'].includes(wheelGuards) || (trundle === '1500' && waterTank)) throw new Error('selection_error');
      return { bundleHandle: this.config.bundleHandle, quantity, vehicle, extras: { trundle, waterTank, wheelGuards } };
    }

    syncSelection() {
      let valid = false;
      try { this.selection(); valid = true; } catch (_) {}
      // A saved request can be viewed or retried with its original vehicle.
      if (this.trigger) this.trigger.disabled = !valid && !this.attempt;
      const needsSelection = !this.attempt || this.attempt.canEdit === true;
      this.submit.disabled = this.busy || this.attempt?.status === 'review_required'
        || this.attempt?.retryAllowed === false || (needsSelection && !valid);
    }

    message(key) {
      this.status.classList.remove('service-body-install-quote-ready');
      this.status.textContent = this.config.messages[key] || this.config.messages.network_error;
      this.status.focus();
    }

    save() {
      try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.attempt)); }
      catch (_) { this.storageReady = false; throw new Error('storage_error'); }
    }

    show(result) {
      this.status.textContent = result.status === 'error' && typeof result.message === 'string' ? result.message
        : this.config.messages[result.status] || this.config.messages.network_error;
      this.reference.textContent = `${this.config.messages.reference} ${result.reference || this.attempt.payload.submissionId}`;
      this.reference.hidden = result.status === 'quote_ready';
      const ready = result.status === 'quote_ready';
      this.status.classList.toggle('service-body-install-quote-ready', ready);
      const editable = result.status === 'error' && result.canEdit === true && result.retryAllowed === true;
      this.fields.disabled = !editable;
      this.submit.hidden = ready;
      this.submit.disabled = this.busy || result.status === 'review_required' || result.retryAllowed === false;
      this.submit.textContent = editable ? this.config.messages.submit : this.config.messages.retry;
      this.restart.hidden = !ready;
      this.result.hidden = !ready;
      this.changed.hidden = true;
      if (ready) {
        const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
        this.querySelector('[data-install-bundle]').textContent = formatter.format(Number(result.amounts.bundleAmount));
        this.querySelector('[data-install-cost]').textContent = formatter.format(Number(result.amounts.installAmount));
        this.querySelector('[data-install-total]').textContent = formatter.format(Number(result.amounts.totalAmount));
        const totalCents = Math.round(Number(result.amounts.totalAmount) * 100);
        const depositCents = Math.round(totalCents / 4);
        this.querySelector('[data-install-deposit]').textContent = formatter.format(depositCents / 100);
        const pricing = this.attempt.pricing;
        const quantity = this.attempt.payload.quantity;
        const bundleCents = Math.round(Number(result.amounts.bundleAmount) * 100);
        const savings = pricing && Number.isSafeInteger(pricing.price) && pricing.price > 0
          && Number.isSafeInteger(pricing.compareAtPrice) && pricing.compareAtPrice > pricing.price
          && Number.isSafeInteger(quantity) && quantity > 0 && quantity <= 10
          && Number.isSafeInteger(pricing.compareAtPrice * quantity) && pricing.price * quantity === bundleCents;
        this.querySelector('[data-install-regular-row]').hidden = !savings;
        this.querySelector('[data-install-savings-row]').hidden = !savings;
        if (savings) {
          this.querySelector('[data-install-regular]').textContent = formatter.format(pricing.compareAtPrice * quantity / 100);
          this.querySelector('[data-install-savings]').textContent = `-${formatter.format((pricing.compareAtPrice - pricing.price) * quantity / 100)}`;
        }
        try {
          const { submissionId, customer, installLocation, installOptions, ...saved } = this.attempt.payload;
          this.changed.hidden = JSON.stringify(saved) === JSON.stringify(this.selection());
        } catch (_) { this.changed.hidden = false; }
      }
      this.syncSelection();
    }

    validAmounts(amounts) {
      if (amounts?.currencyCode !== 'AUD') return false;
      const values = ['bundleAmount', 'installAmount', 'totalAmount'].map(key => {
        const value = amounts[key];
        return typeof value === 'string' && /^\d+\.\d{2}$/.test(value) ? Math.round(Number(value) * 100) : NaN;
      });
      return values.every(value => Number.isSafeInteger(value) && value > 0) && values[0] + values[1] === values[2];
    }

    async send(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.attempt?.status === 'quote_ready' || this.attempt?.status === 'review_required') return;
      if (!this.storageReady) { this.message('storage_error'); return; }
      if (!this.endpoint) { this.message('unavailable'); return; }
      let timer;
      try {
        if (!this.attempt || this.attempt.canEdit === true) {
          if (!this.form.reportValidity()) return;
          const selection = this.selection();
          const customer = Object.fromEntries(['firstName', 'lastName', 'email', 'phone'].map(key => [key, this.form.elements.namedItem(key).value.trim()]));
          const installOptions = Array.from(this.form.querySelectorAll('[name="installOptions"]:checked'), control => control.value);
          const variant = this.nativeForm.querySelector('service-body-vehicle')?.variant;
          const pricing = { price: variant?.price, compareAtPrice: variant?.compareAtPrice };
          this.attempt = { payload: { submissionId: this.attempt?.payload.submissionId || crypto.randomUUID(), ...selection, customer, installLocation: this.form.elements.namedItem('installLocation').value, installOptions }, pricing, status: 'processing', canEdit: false };
          this.save();
        }
        this.busy = true;
        this.fields.disabled = true;
        this.submit.disabled = true;
        this.submit.setAttribute('aria-busy', 'true');
        this.message('checking');
        const controller = new AbortController();
        timer = window.setTimeout(() => controller.abort(), 30000);
        const response = await fetch(this.endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(this.attempt.payload), signal: controller.signal });
        const result = await response.json();
        if (!result || !['quote_ready', 'processing', 'review_required', 'error'].includes(result.status)
          || (result.status === 'quote_ready' && (!result.ok || !this.validAmounts(result.amounts)))) throw new Error('network_error');
        this.attempt = { ...result, payload: this.attempt.payload, pricing: this.attempt.pricing, canEdit: result.status === 'error' && result.canEdit === true && result.retryAllowed === true };
        this.save();
        this.show(this.attempt);
        this.status.focus();
      } catch (error) {
        this.message(['selection_error', 'storage_error'].includes(error.message) ? error.message : 'network_error');
        if (this.attempt) {
          this.reference.textContent = `${this.config.messages.reference} ${this.attempt.payload.submissionId}`;
          this.reference.hidden = false;
          this.submit.textContent = this.config.messages.retry;
        }
      } finally {
        window.clearTimeout(timer);
        this.busy = false;
        this.submit.removeAttribute('aria-busy');
        this.syncSelection();
      }
    }
  });
}
